if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        
        this.isDragging = false;
        this.hasDragged = false;
        this.startX = 0;
        this.startY = 0;
        
        // Speichere Pan-Position pro Bild-URL
        this.imageTranslations = new Map();
        
        // ✅ NEU: Stelle sicher, dass Close-Button immer vorne ist
        const closeButton = this.querySelector('[id^="ModalClose-"]');
        if (closeButton) {
          closeButton.style.zIndex = '999';
          closeButton.style.position = 'relative';
        }
        
        // Nur INNERHALB der geöffneten Lightbox aktiv
        this.addEventListener('click', (e) => {
          const isOpen = this.hasAttribute('open');
          
          if (isOpen) {
            // X-Button darf schließen
            if (e.target.closest('[id^="ModalClose-"]')) {
              return;
            }
            
            // Blockiere Click komplett wenn gedragged wurde
            if (this.hasDragged) {
              e.stopPropagation();
              e.preventDefault();
              this.hasDragged = false;
              return;
            }
            
            // Click-to-Zoom nur bei echtem Klick
            if (e.target.tagName === 'IMG') {
              e.stopPropagation();
              this.toggleZoom(e.target);
            }
          }
        }, true);
        
        // Mouse-Events für Pan-Funktion
        this.addEventListener('mousedown', (e) => {
          const img = e.target;
          if (img.tagName === 'IMG' && img.classList.contains('zoomed')) {
            this.isDragging = true;
            this.hasDragged = false;
            
            const imgKey = img.src;
            const translation = this.imageTranslations.get(imgKey) || { x: 0, y: 0 };
            
            this.startX = e.clientX - translation.x;
            this.startY = e.clientY - translation.y;
            img.style.cursor = 'grabbing';
            e.preventDefault();
          }
        });
        
        this.addEventListener('mousemove', (e) => {
          if (!this.isDragging) return;
          
          this.hasDragged = true;
          const img = this.querySelector('img.zoomed');
          if (img) {
            const imgKey = img.src;
            const translateX = e.clientX - this.startX;
            const translateY = e.clientY - this.startY;
            
            this.imageTranslations.set(imgKey, { x: translateX, y: translateY });
            
            img.style.transform = `scale(2) translate(${translateX / 2}px, ${translateY / 2}px)`;
          }
        });
        
        this.addEventListener('mouseup', () => {
          if (this.isDragging) {
            this.isDragging = false;
            const img = this.querySelector('img.zoomed');
            if (img) {
              img.style.cursor = 'grab';
            }
          }
        });
        
        this.addEventListener('mouseleave', () => {
          if (this.isDragging) {
            this.isDragging = false;
            const img = this.querySelector('img.zoomed');
            if (img) {
              img.style.cursor = 'grab';
            }
          }
        });
      }

      toggleZoom(img) {
        const isZoomed = img.classList.contains('zoomed');
        const imgKey = img.src;
        
        if (isZoomed) {
          img.classList.remove('zoomed');
          img.style.transform = 'scale(1)';
          img.style.cursor = 'zoom-in';
          img.style.transition = 'none';
          img.style.zIndex = '1';
          img.style.position = 'relative';
          this.imageTranslations.delete(imgKey);
        } else {
          // Starte mit Position 0,0 für neues Bild
          if (!this.imageTranslations.has(imgKey)) {
            this.imageTranslations.set(imgKey, { x: 0, y: 0 });
          }
          
          // Alle anderen Bilder zurücksetzen
          this.querySelectorAll('img').forEach(otherImg => {
            if (otherImg !== img) {
              otherImg.style.zIndex = '1';
              otherImg.style.position = 'relative';
            }
          });
          
          img.classList.add('zoomed');
          img.style.transform = 'scale(2)';
          img.style.cursor = 'grab';
          img.style.transition = 'none';
          img.style.zIndex = '2';
          img.style.position = 'relative';
        }
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
